export const isClosedByClickingOutside = (reason?: string) => {
    return Boolean(
        reason === "escapeKeyDown"
        || reason === "backdropClick"
    );
}